import { FlagBadge, createFlagBadge } from '@vfde-brix/ws10/flag-badge';
import { HtmlId, JarvisSuggestionType } from '../enum';
import { mountComponent } from '../util/mount';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { getPrimaryFlagText, getSecondaryFlagText } from '../util/cms';

export const mountFlagBadge = (id: HtmlId) =>
    mountComponent(id, createFlagBadge, NO_PATTERN_BUSINESS_LOGIC);

export const updateFlagBadge = (comp: FlagBadge | null, text?: string) => {
    comp?.update({ stdLabel: text });
    comp?.toggleContainer(!text);
};

export const updatePrimaryFlagBadge = (comp: FlagBadge | null, secondary?: JarvisSuggestionType) => {
    const text = getPrimaryFlagText(secondary);

    updateFlagBadge(comp, text);
};

export const updateSecondaryFlagBadge = (comp: FlagBadge | null, secondary?: JarvisSuggestionType) => {
    const text = getSecondaryFlagText(secondary);

    updateFlagBadge(comp, text);
};
